import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import dayjs from "common/dayjs";
import { RECEIPT_DATE_FORMAT } from "common/constants";
import { BadgeSyncStatus } from "common/enums";
import { ReactComponent as LastTimeDownloadIcon } from "../../../../assets/LastTimeDownloadIcon.svg";
import { ReactComponent as FileDownloadIcon } from "../../../../assets/FileDownloadIcon.svg";
import { ReactComponent as ErrorDownloadIcon } from "../../../../assets/ErrorDownloadIcon.svg";
import colors from "../../../../common/styles/colors";
import { useTranslation } from "react-i18next";

export const BadgeSyncChip = () => {
  const { t } = useTranslation("common");
  const lastBadgeUpdateTime = useSelector((state: RootState) => state.metadata.lastBadgeUpdateTime);
  const badgeSyncStatus = useSelector((state: RootState) => state.metadata.badgeSyncStatus);

  const parsedDate = dayjs(lastBadgeUpdateTime, "UTC").local().format(RECEIPT_DATE_FORMAT);

  const getChipProps = () => {
    switch (badgeSyncStatus) {
      case BadgeSyncStatus.DOWNLOADING:
        return {
          label: t("header.badgeSync.downloadingData"),
          icon: <FileDownloadIcon />,
          color: "warning" as const,
          sx: { whiteSpace: "nowrap", padding: "6px", backgroundColor: colors.yellow[200], color: colors.yellow[800] }
        };
      case BadgeSyncStatus.DOWNLOAD_FAILED:
        return {
          label: t("header.badgeSync.downloadingFailed"),
          icon: <ErrorDownloadIcon />,
          color: "error" as const,
          sx: { whiteSpace: "nowrap", padding: "6px", backgroundColor: colors.red[100], color: colors.red[800] }
        };
      case BadgeSyncStatus.SYNCING_FAILED:
        return {
          label: t("header.badgeSync.syncingFailed"),
          icon: <ErrorDownloadIcon />,
          color: "error" as const,
          sx: { whiteSpace: "nowrap", padding: "6px", backgroundColor: colors.red[100], color: colors.red[800] }
        };
      case BadgeSyncStatus.SUCCESS:
      default:
        return {
          label: parsedDate,
          icon: <LastTimeDownloadIcon />,
          variant: "outlined" as const,
          sx: { whiteSpace: "nowrap", padding: "6px", backgroundColor: colors.white, color: colors.grey[900] }
        };
    }
  };

  const chip = <Chip data-testid="last-badge-sync-chip" size="small" {...getChipProps()} />;

  return badgeSyncStatus === BadgeSyncStatus.SUCCESS ? (
    <Tooltip title={t("header.badgeSync.systemLastSync")} arrow>
      {chip}
    </Tooltip>
  ) : (
    chip
  );
};
